import { environment } from 'src/environment';
import { Component, Input, OnInit, OnChanges, EventEmitter, Output } from '@angular/core';
import { BaseService, StorageService } from 'src/app/core/services';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { DatalayerService } from 'src/app/core/services/datalayer.service';
import { MyAccountService } from 'src/app/core/services/my-account.service';
import { SubscriptionService } from 'src/app/core/services/subscription.service';
import { ChangePlanComponent } from '../change-plan/change-plan.component';
import { churnService } from 'src/app/core/services/churn.service';

@Component({
  selector: 'app-cancel-sub',
  templateUrl: './cancel-sub.component.html',
  styleUrls: ['./cancel-sub.component.scss', '../modal-screens.scss']
})
export class CancelSubComponent implements OnInit, OnChanges {

  cancelled: boolean = false;
  transactionDetails: any = {};
  error: boolean = false;
  expiryDate: any = ''; 
  @Input() subscribedPlan: any;
  @Input() page;
  @Input() userDataChild;
  @Output() newItemEvent? = new EventEmitter<string>();
  @Output() updateTitleEvent? = new EventEmitter<string>();
  paymentType;

  skinName = environment.skinName;
  constructor(public configService: ConfigurationService,
     private datalayerService: DatalayerService, private storageService: StorageService,
     private subscriptionService: SubscriptionService, private accountService: MyAccountService,
     private baseService:BaseService, private churnService: churnService) {
  }
  
  ngOnInit(): void {
    if(this.page == 'account' && this.userDataChild){
      this.processAccountDetail(this.userDataChild)
    }else{
      this.accountService.getAccountDetails().subscribe(data => {
        this.processAccountDetail(data)
      });
    }
  }

  processAccountDetail(data){
    this.expiryDate = data.payment_method?.next_due_date;
    this.paymentType = data.payment_method?.payment_type;
    if(this.cancelled){
      this.updateTitleEvent.emit(this.configService.localeKeys?.["account.success.text"]);
      this.newItemEvent.emit('cancel');
    }
  }

  ngOnChanges(): void{
    this.cancelled = this.subscribedPlan.cancel_subscription == '1';
  }

  async setCancelled(){
    const datalayerRefundData = {
      ecommerce: {
        refund: {
          actionField: {
            id: this.subscribedPlan.reference_id, // Transaction ID. Required for purchases and refunds.
          }
        }
      }
    };
    this.datalayerService.addDatalayer(datalayerRefundData);
    const data = {
      subscription_id: this.subscribedPlan.subscription_id,
      u_id: this.storageService.getLocalStore('u_id'),
      stripe_subscription_id: this.subscribedPlan.orderId
    };
    let cancelSubscriptionRes;
    if (this.paymentType === 'free-plan') {
      cancelSubscriptionRes = await this.churnService.cancellingFreeSubscription(data).toPromise();
    } else {
      cancelSubscriptionRes = await this.churnService.cancellingSubscription(data).toPromise();
    }
    if (cancelSubscriptionRes.status_code === 200) {
      this.churnService.cancelSubscriptionGAEvent(this.subscribedPlan);
      this.cancelled = true;
      this.transactionDetails = cancelSubscriptionRes.data;
      // this.expiryDate = new Date(cancelSubscriptionRes.data.expiry_date.replace(/-/g, "/")).toDateString().substring(4);
      this.expiryDate = cancelSubscriptionRes.data.expiry_date;
      this.updateTitleEvent.emit(this.configService.localeKeys?.["account.success.text"]);
      this.newItemEvent.emit('cancel');
    } else {
      this.cancelled = false;
      this.error = true;
      this.transactionDetails = cancelSubscriptionRes.error;
    }
  }

}
